module.exports = __webpack_public_path__ + "static/media/wildlife.a00f5303.jpg";